import { Grid } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import {
  Add,
  Button,
  // Add,
  // Button,
  // CardComponent,
  // ComplianceAssuranceCard,
  ComplianceAssuranceTable,
  ConfirmationPopup,
  Exclamation,
  // Layers,
  NoComplianceAssurances,
  // SvgTable,
  TextField,
  // ToggleGroup,
} from '@HomaHealth/ui-component-library/lib/_AIQ-components';
import React, { useEffect, useState } from 'react';
import Loader from '../../_components/molecules/Loader';
import {
  ComplianceAssuranceType,
  formatComplianceAssuranceData,
} from '../../core-utils/helper-utils/contractAIQHelper';
import AddGroupPopup from '../../_components/organisms/AddGroupPopup';
import {
  CONTRACT_ONBOARDING,
  EXPERICENCE_SCREEN,
  // EXPERICENCE_SCREEN,
} from '../../core-utils/routes';
import { useStores } from '../../stores';
import { useNavigate } from 'react-router-dom';
import { getAllEmployerGroups } from '../../core-utils/helper-utils/reportsWorkFlowHelper';
import { Pagination } from '@mui/material';
import { AlertColor as MuiColor } from '@mui/material/Alert';
import Snackbar from '../../_components/atoms/Snackbar';
import axios from 'axios';
import properties from '../../core-utils/properties';
import { patientAccessTheme } from '@HomaHealth/ui-component-library/lib/theme/theme';
import { IEmployerGroupResponseData } from '../HomePage';
import { observer } from 'mobx-react';
import contractAIQConstants from '../../core-utils/messages/ContractAIQConstants';
import { getCurrentTimestamp } from '../../core-utils/helper-utils/helper';
import GifWithLabels from '@HomaHealth/ui-component-library/lib/_patient-access-components/molecules/GIFWithLabels';
import {
  SimpleSearch,
  Typography,
} from '@HomaHealth/ui-component-library/lib/_patient-access-components';
import NoResults from '../../../public/Images/NoResults.png';
import {
  formatUserAccessRoutes,
  UserAccessConstants,
} from '../../core-utils/helper-utils/userAccess';
import { toJS } from 'mobx';
import { createEmployerGroupData } from '../../core-utils/helper-utils/homePageHelper';
// import { CSSProperties } from '@mui/material/styles/withStyles';
// import AppCard from '../../_components/atoms/AppCard';
// import { RECOMMENDED_APPS } from '../../core-utils/messages/RecommendedAppConstants';

const useStyles = makeStyles()({
  root: {
    marginTop: '28px',
  },
  addNewGroupGrid: {
    display: 'flex',
    alignItems: 'center',
    gap: '24px',
  },
  cards: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '24px',
  },
  seeMoreCard: {
    width: '360px',
    height: '223px',
    borderRadius: '8px',
    backgroundColor: patientAccessTheme.palette.status.white,
    boxShadow: '0px 4px 20px rgb(69 70 77 / 6%)',
    border: '1px solid ' + patientAccessTheme.palette.grey[300],
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  pagination: {
    display: 'flex',
    justifyContent: 'right',
    marginTop: '16px',
  },
  noGroups: {
    display: 'flex',
    alignItems: 'center',
    height: '290px',
    justifyContent: 'center',
  },
  text: {
    background: patientAccessTheme.palette.grey[100],
    borderRadius: '4px',
    padding: '3px 17px',
  },
  tableContainer: {
    width: '100%',
  },
});

const ComplianceAssurance = observer(() => {
  //Constants
  const { classes } = useStyles();
  const navigate = useNavigate();
  const employerGroupStore = useStores().employerGroupStore;
  const complianceAssuranceStore = useStores().complianceAssuranceStore;
  const loginPageStore = useStores().loginPageStore;
  const userDetailsStore = useStores().userDetailsStore;
  const careNavigatorStore = useStores().careNavigatorStore;

  const messages = contractAIQConstants.COMPLIANCE_ASSURANCE_CRUD;
  const allEmployerGroups = getAllEmployerGroups(
    employerGroupStore.allEmployerGroupsData,
  );
  // const initialGroupFields = {
  //   'Claims Administrator': '',
  //   PBM: '',
  //   'Stop loss carrier': '',
  //   'Network Carrier': '',
  //   'Broker/ Advisor/ Consultant': '',
  // };
  const initialGroupFields = {
    funding_type: '',
    employee_count: '',
    // renewal_date: '',
    renewal_month: '',

    states: [],
  };
  let newGroupId = '';
  // const apps = RECOMMENDED_APPS.APPS;

  //States
  // const [showAllApps, setShowAllApps] = useState<boolean>(false);
  const [complianceAssurancesGroups, setComplianceAssuranceGroups] = useState<
    ComplianceAssuranceType[]
  >([]);
  const addGroupData = allEmployerGroups?.filter(
    (item1) =>
      !complianceAssurancesGroups?.some(
        (item2) => item1.eg_nid === item2.eg_nid,
      ),
  );
  const addGroupOptions = addGroupData?.map((item) => item?.name);
  const addGroupValues = addGroupData?.map((item) => item?.eg_nid);
  const [isAddGroupPopupOpen, setIsAddGroupPopupOpen] = useState<boolean>(
    false,
  );
  const [groupId, setGroupId] = useState<string>('');
  const [groupFieldsData, setGroupFieldsData] = useState<any>(
    initialGroupFields,
  );
  const [editGroupInfo, setEditGroupInfo] = useState({
    isEdit: false,
    id: '',
    egNid: '',
  });
  const [isDeletePopupOpen, setIsDeletePopupOpen] = useState<boolean>(false);
  const [snackbarState, setSnackbarState] = React.useState<{
    open: boolean;
    message: string;
    severity: MuiColor | undefined;
    duration: null | number;
  }>({
    open: false,
    message: '',
    severity: undefined,
    duration: null,
  });
  // const [toggleState, setToggleState] = useState('right');
  const [loading, setLoading] = useState<boolean>(true);
  // const [showSeeMore, setShowSeeMore] = useState<boolean>(false);
  const [totalPages, setTotalPages] = useState<number>(0);
  const [pageNumber, setPageNumber] = useState<number>(1);
  const [searchText, setSearchText] = useState<string>('');
  const [groupsExist, setGroupsExist] = useState<boolean>(false);

  // const appsToDisplay = showAllApps ? apps : apps.slice(0, 6);

  //Functions
  // const handleToggleApps = () => {
  //   setShowAllApps((prev) => !prev);
  // };

  const handleCloseSnackBar = () => {
    setSnackbarState({
      open: false,
      message: '',
      severity: undefined,
      duration: null,
    });
  };

  const handleOpenSnackBar = (
    message: string,
    severity: MuiColor,
    duration: number | null,
  ) => {
    setSnackbarState({
      open: true,
      message: message,
      severity: severity,
      duration: duration,
    });
  };

  const handleGroupsTablePageChange = (
    event: React.ChangeEvent<unknown>,
    value: number,
  ) => {
    setPageNumber(value);
  };

  const handleEmployerSelection = (eg_nid: string, employer_name?: string) => {
    const selectedEmployer = employerGroupStore?.allEmployerGroupsData?.find(
      (item) => item?.eg_nid === eg_nid,
    );
    const employerData: IEmployerGroupResponseData = selectedEmployer
      ? {
          ...selectedEmployer,
          eg_nid: [selectedEmployer.eg_nid],
          employer_group_name: [selectedEmployer.employer_group_name],
        }
      : createEmployerGroupData(eg_nid, employer_name!);

    employerGroupStore.setEmployerGroupResponseData(employerData);
    if (selectedEmployer?.care_navigation_id) {
      careNavigatorStore.setGroupData(
        selectedEmployer?.care_navigation_id,
        selectedEmployer?.employer_group_name[0],
        selectedEmployer.eg_nid[0],
        true,
      );
    }
    employerGroupStore.setIsIndividualGroup(true);
  };

  const handleOpenAddGroup = () => {
    setIsAddGroupPopupOpen(true);
  };

  const handleCloseAddGroup = () => {
    setGroupId('');
    setGroupFieldsData(initialGroupFields);
    setEditGroupInfo({ isEdit: false, id: '', egNid: '' });
    setIsAddGroupPopupOpen(false);
  };

  const handleSaveAddGroup = async () => {
    await addComplianceAssuranceGroup();
    await getComplianceAssuranceGroups();
    handleCloseAddGroup();
  };

  const handleOnBoardingAddGroup = async () => {
    if (editGroupInfo?.isEdit) {
      await editComplianceAssuranceGroup(editGroupInfo?.id);
    } else {
      await addComplianceAssuranceGroup();
      const employer = allEmployerGroups?.find(
        (item) => item?.eg_nid === groupId,
      );
      const egNid = employer?.eg_nid ?? newGroupId;
      const employerName = employer?.name ?? groupId;
      handleEmployerSelection(egNid, employerName);
      navigate(CONTRACT_ONBOARDING);
    }
    handleCloseAddGroup();
  };

  const handleDeleteGroup = async () => {
    await deleteComplianceAssuranceGroup(editGroupInfo?.id);
    setIsDeletePopupOpen(false);
    await getComplianceAssuranceGroups();
  };

  const handleMenuOnClick = async (row: any, menu: string) => {
    switch (menu) {
      case 'edit':
        await getComplianceAssuranceGroupById(row?.id);
        setEditGroupInfo({ isEdit: true, id: row?.id, egNid: row?.eg_nid });
        setIsAddGroupPopupOpen(true);
        break;
      case 'onboard':
        handleEmployerSelection(row?.eg_nid, row?.group);
        complianceAssuranceStore.setGroupId(row?.id);
        navigate(CONTRACT_ONBOARDING);
        break;
      case 'delete':
        setEditGroupInfo({ isEdit: false, id: row?.id, egNid: row?.eg_nid });
        setIsDeletePopupOpen(true);
        break;
      default:
        break;
    }
  };

  const handleSearchGroups = (event: any) => {
    setSearchText(event.target.value);
    setPageNumber(1);
  };

  //API calls
  const getComplianceAssuranceGroups = async () => {
    await axios
      .post(
        properties.aiqBaseUrl +
          properties.contractBaseUrl +
          properties.getAllGroups,
        {
          page: pageNumber,
          size: 5,
          usePagination: true,
          searchTerm: searchText,
          eg_nids: userDetailsStore.userAccess
            ? userDetailsStore.complianceAssuranceGroups?.map(
                (group) => group.egNid,
              )
            : [],
        },
      )
      .then((res: any) => {
        if (res.status === 200) {
          const data = res?.data?.data;
          if (searchText === '') {
            setGroupsExist(data?.groups?.length > 0);
          }
          setComplianceAssuranceGroups(
            formatComplianceAssuranceData(data?.groups),
          );
          setTotalPages(data?.totalPages);
          setLoading(false);
        }
      })
      .catch((error) => {
        handleOpenSnackBar(error.response?.data?.error, 'error', 6000);
      });
  };

  const saveOrganizationInfo = async (egNid: string) => {
    try {
      await Promise.all([
        axios.put(
          properties.aiqBaseUrl +
            properties.dataCatalogueBaseURL +
            properties.updateGeneralOrganizationInfo,
          {
            eg_nid: egNid,
            number_of_employees: groupFieldsData['employee_count'],
          },
        ),
        axios.put(
          properties.aiqBaseUrl +
            properties.dataCatalogueBaseURL +
            properties.updateEmployeeHealthPlan,
          {
            eg_nid: egNid,
            // renewal_date: groupFieldsData['renewal_date'],
            renewal_month: groupFieldsData['renewal_month'],
            plan_funding_type: groupFieldsData['funding_type'],
            states_of_employees: groupFieldsData['states'],
          },
        ),
      ]);
    } catch (error) {
      handleOpenSnackBar(
        'Error Updating General Organization Information',
        'error',
        3000,
      );
    }
  };

  const addComplianceAssuranceGroup = async () => {
    let egNid = '';
    const employer = allEmployerGroups?.find(
      (item) => item?.eg_nid === groupId,
    );

    if (employer) {
      egNid = employer?.eg_nid;
    } else {
      egNid =
        groupId?.replace(' ', '_')?.toLowerCase() + '_' + getCurrentTimestamp();
      newGroupId = egNid;
    }
    await axios
      .post(
        properties.aiqBaseUrl +
          properties.contractBaseUrl +
          properties.addGroup,
        {
          eg_nid: egNid,
          employer_name:
            allEmployerGroups?.find((item) => item?.eg_nid === groupId)?.name ||
            groupId,
          tpa: groupFieldsData['Claims Administrator'],
          pbm: groupFieldsData['PBM'],
          stop_loss_carrier: groupFieldsData['Stop loss carrier'],
          advisor_or_broker: groupFieldsData['Broker/ Advisor/ Consultant'],
          network: groupFieldsData['Network Carrier'],
        },
      )
      .then(async (res: any) => {
        if (res.status === 200) {
          await saveOrganizationInfo(egNid);

          if (res?.data?.data?.error) {
            handleOpenSnackBar(res?.data?.data?.error, 'error', 5000);
          } else {
            const { _id, eg_nid, employer_name } = res?.data?.data;
            complianceAssuranceStore.setGroupId(_id);
            const updatedEmployerGroups = [
              ...employerGroupStore.allEmployerGroupsData,
              {
                eg_nid: eg_nid,
                employer_group_name: employer_name,
              } as any,
            ];
            employerGroupStore.setAllEmployerGroupsData(updatedEmployerGroups);
            handleOpenSnackBar(
              'Compliance Assurance Group saved successfully',
              'success',
              5000,
            );
          }
        }
      })
      .catch((error) => {
        handleOpenSnackBar(error.response?.data?.error, 'error', 6000);
      });
  };

  const editComplianceAssuranceGroup = async (group_id: string) => {
    await axios
      .post(
        properties.aiqBaseUrl +
          properties.contractBaseUrl +
          properties.updateGroup,
        {
          group_id: group_id,
          tpa: groupFieldsData['Claims Administrator'],
          pbm: groupFieldsData['PBM'],
          stop_loss_carrier: groupFieldsData['Stop loss carrier'],
          advisor_or_broker: groupFieldsData['Broker/ Advisor/ Consultant'],
          network: groupFieldsData['Network Carrier'],
        },
      )
      .then(async (res: any) => {
        if (res.status === 200) {
          await saveOrganizationInfo(editGroupInfo?.egNid || groupId);
          handleOpenSnackBar(
            'Compliance Assurance Group updated successfully',
            'success',
            5000,
          );
        }
      })
      .catch((error) => {
        handleOpenSnackBar(error.response?.data?.error, 'error', 6000);
      });
  };

  const deleteComplianceAssuranceGroup = async (group_id: string) => {
    await axios
      .post(
        properties.aiqBaseUrl +
          properties.contractBaseUrl +
          properties.deleteGroup,
        {
          group_id: group_id,
        },
      )
      .then((res: any) => {
        if (res.status === 200) {
          handleOpenSnackBar(
            'Compliance Assurance Group deleted successfully',
            'success',
            5000,
          );
        }
      })
      .catch((error) => {
        handleOpenSnackBar(error.response?.data?.error, 'error', 6000);
      });
  };

  const getComplianceAssuranceGroupById = async (group_id: string) => {
    await axios
      .post(
        properties.aiqBaseUrl +
          properties.contractBaseUrl +
          properties.getGroupById,
        {
          group_id: group_id,
        },
      )
      .then(async (res: any) => {
        if (res.status === 200) {
          const data = res?.data?.data;

          const response = await axios.post(
            properties.aiqBaseUrl +
              properties.dataCatalogueBaseURL +
              properties.getOrganizationInfo,
            {
              eg_nid: [data?.eg_nid],
            },
          );

          setGroupId(data?.employer_name);
          // setGroupFieldsData({
          //   'Claims Administrator': data?.tpa,
          //   PBM: data?.pbm,
          //   'Stop loss carrier': data?.stop_loss_carrier,
          //   'Network Carrier': data?.network,
          //   'Broker/ Advisor/ Consultant': data?.advisor_or_broker,
          // });
          const { employer_plan, general_info } = response?.data?.data;
          setGroupFieldsData({
            funding_type: employer_plan?.plan_funding_type,
            // renewal_date: employer_plan?.renewal_date,
            renewal_month: employer_plan?.renewal_month,
            employee_count: general_info?.number_of_employees,
            states: employer_plan?.states_of_employees,
          });
        }
      })
      .catch((error) => {
        handleOpenSnackBar(error.response?.data?.error, 'error', 6000);
      });
  };

  //UseEffects
  useEffect(() => {
    getComplianceAssuranceGroups();
  }, [pageNumber, searchText]);

  const updateUserAccess = (
    egNid: string,
    riskGroups: any[],
    complianceGroups: any[],
    careNavigationGroups: any[],
  ) => {
    if (userDetailsStore.userAccess) {
      const riskRoutes =
        riskGroups?.find((group) => egNid === group.egNid)?.screens || [];
      const complianceRoutes =
        complianceGroups?.find((group) => egNid === group.egNid)?.screens || [];
      const careNavigationRoutes =
        careNavigationGroups?.find((group) => egNid === group.egNid)?.screens ||
        [];

      const {
        userFeatures,
        userAccessRoutes: formatedUserAccessibleRoutes,
      } = formatUserAccessRoutes([
        ...riskRoutes,
        ...complianceRoutes,
        ...careNavigationRoutes,
      ]);

      loginPageStore.addUserAccessRoutes(formatedUserAccessibleRoutes);
      loginPageStore.addUserFeatures(userFeatures);
      loginPageStore.setMemberIdentification(
        userFeatures?.includes(UserAccessConstants.MEMBER_IDENTIFICATION),
      );
    }
  };

  //Components
  // const ComplianceAssuranceCards = () => {
  //   return (
  //     <Grid className={classes.cards}>
  //       {complianceAssurancesGroups?.map((item, index: number) => {
  //         // Show the first 5 cards initially
  //         if (index < 5 || showSeeMore) {
  //           return (
  //             <ComplianceAssuranceCard
  //               key={index}
  //               title={item?.group}
  //               values={[
  //                 item?.claimsAdministrator,
  //                 item?.pbm,
  //                 item?.stoplossCarrier,
  //                 item?.advisor,
  //                 item?.networkCarrier,
  //               ]}
  //               labels={messages.LABELS}
  //               status={item.status}
  //               handleOnClick={() => {
  //                 handleEmployerSelection(item?.eg_nid, item?.group);
  //                 updateUserAccess(
  //                   item.eg_nid,
  //                   toJS(userDetailsStore.riskManagementGroups),
  //                   toJS(userDetailsStore.complianceAssuranceGroups),
  //                   toJS(userDetailsStore.careNavigationGroups),
  //                 );
  //                 history.push(COMPLIANCE_ASSURANCE);
  //               }}
  //               handleMenuOnClick={(id) => handleMenuOnClick(item, id)}
  //             />
  //           );
  //         }

  //         // Show the "Show More" card if it's the 6th card (index === 5)
  //         if (index === 5 && !showSeeMore) {
  //           return (
  //             <Grid key={index} className={classes.seeMoreCard}>
  //               <Button
  //                 variant="text"
  //                 color="primary"
  //                 label={messages.SHOW_ALL}
  //                 onClick={() => {
  //                   setShowSeeMore(true);
  //                 }}
  //                 width="auto"
  //               />
  //             </Grid>
  //           );
  //         }

  //         return null; // Do not render anything by default for other conditions
  //       })}
  //       {showSeeMore && (
  //         <Grid key="show-less" className={classes.seeMoreCard}>
  //           <Button
  //             variant="text"
  //             color="primary"
  //             label={'Show Less Groups'}
  //             onClick={() => setShowSeeMore(false)}
  //             width="auto"
  //           />
  //         </Grid>
  //       )}
  //     </Grid>
  //   );
  // };

  const ComplianceAssurancesTable = () => {
    return (
      <Grid className={classes.tableContainer}>
        <ComplianceAssuranceTable
          rowsData={complianceAssurancesGroups}
          handleRowClick={(row: any) => {
            handleEmployerSelection(row?.eg_nid, row?.group);
            updateUserAccess(
              row.eg_nid,
              toJS(userDetailsStore.riskManagementGroups),
              toJS(userDetailsStore.complianceAssuranceGroups),
              toJS(userDetailsStore.careNavigationGroups),
            );

            navigate(EXPERICENCE_SCREEN, {
              state: { defaultTab: 'Documents' },
            });
          }}
          handleMenuOnClick={handleMenuOnClick}
          width="100%"
        />
        {totalPages > 1 && (
          <div className={classes.pagination}>
            <Pagination
              page={pageNumber}
              count={totalPages}
              onChange={handleGroupsTablePageChange}
              size="small"
              color="primary"
            />
          </div>
        )}
      </Grid>
    );
  };

  const NoGroups = () => {
    return (
      <Grid className={classes.noGroups}>
        <GifWithLabels
          mainLabel={
            <Typography
              fontSize="16px"
              fontType="medium"
              lineHeight="24px"
              textColor={patientAccessTheme.palette.text.mediumemphasis}
              className={classes.text}
            >
              {'No Groups Exist !'}
            </Typography>
          }
          subLabel={undefined}
          gifUrl={NoResults}
        />
      </Grid>
    );
  };

  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <Grid className={classes.root}>
          {groupsExist ? (
            <>
              <Grid style={{ display: 'flex', gap: '10px' }}>
                <TextField
                  placeholder={'Search'}
                  height="44px"
                  startAdornment={
                    <SimpleSearch
                      height="24px"
                      width="24px"
                      stroke={patientAccessTheme.palette.text.lowemphasis}
                    />
                  }
                  showStartAdornment={true}
                  value={searchText}
                  onChange={handleSearchGroups}
                  style={{ marginBottom: '24px', width: '82%' }}
                />
                <Button
                  label={messages.ADD_BUTTON}
                  variant="contained"
                  height="44px"
                  width={'166px'}
                  startIcon={<Add />}
                  onClick={handleOpenAddGroup}
                />
              </Grid>

              {complianceAssurancesGroups?.length > 0 ? (
                <ComplianceAssurancesTable />
              ) : (
                <NoGroups />
              )}
            </>
          ) : (
            <NoComplianceAssurances handleOnclick={handleOpenAddGroup} />
          )}
        </Grid>
      )}
      {isAddGroupPopupOpen && (
        <AddGroupPopup
          options={addGroupOptions}
          values={addGroupValues}
          open={isAddGroupPopupOpen}
          groupValue={groupId}
          setGroupValue={setGroupId}
          fieldsData={groupFieldsData}
          setFieldsData={setGroupFieldsData}
          handleSave={handleSaveAddGroup}
          handleStartOnBoarding={handleOnBoardingAddGroup}
          handleClose={handleCloseAddGroup}
          isEdit={editGroupInfo?.isEdit}
          hideGroupTextField={false}
        />
      )}
      {isDeletePopupOpen && (
        <ConfirmationPopup
          handleCancel={() => setIsDeletePopupOpen(false)}
          handleConfirm={handleDeleteGroup}
          icon={<Exclamation width="38px" height="38px" />}
          title={messages.POP_UP.TITLE}
          subTitle={messages.POP_UP.SUBTITLE}
          buttonsType="error"
        />
      )}
      <Snackbar
        {...snackbarState}
        vertical={'bottom'}
        horizontal={'right'}
        handleClose={handleCloseSnackBar}
      />
    </>
  );
});

export default ComplianceAssurance;
